import * as React from 'react'
import MainView from '../components/MainView'
import { BrowserRouter } from 'react-router-dom'

const App = () => {
  const view = content => {
    return <div data-testid="test-id">{content}</div>
  }
  return view(
    <BrowserRouter>
      <MainView />
    </BrowserRouter>
  )
}

export default App
